import { siteURL } from './vercel';

export const SITE_NAME = "Starlight Children's Foundation";
export const SITE_DESCRIPTION = 'Starlight delivers happiness to seriously ill kids';
export const SITE_URL = siteURL();
export const SITE_IMAGE = `${SITE_URL}/img/og-image-default.png`;

export const HOMEPAGE_LANDING_PAGE_SLUG = 'home';

export const CONTENTFUL_NAVIGATION_ID = '2sAHTUuW7y6iP1mbi6J2uG';
export const CONTENTFUL_FOOTER_NAVIGATION_ID = '26eQgRhb1xp5qYT1ec4r6a';

export const CONTENTFUL_HAPPY_GRAM_HERO_ID = '4YSz0WaSe23c28iY54WGg9';

export const EMAIL_COLLECTION_ENDPOINT = 'https://go.starlight.org/l/858203/2021-12-28/qhw76';

export const CLASSY_DONATE_URL = 'https://donate.starlight.org/campaign/586322/donate';

export const FORMSPREE_SPONSOR_A_HOSPITAL = 'moqredel';
export const FORMSPREE_FUNDRAISE_TO_SPONSOR_A_HOSPITAL = 'xpzbdjyo';

export const FORMSPREE_DAG_SUBMISSION = 'xyyvrrrb';
export const FORMSPREE_DAG_VOTING = 'xdovnozr';

export const FORMSPREE_FUND_A_PROGRAM = 'xwkdlkeo';

export const FORMSPREE_HAPPY_GRAM = 'manynlbo';

export const BLOG_POSTS_PER_PAGE = 12;
export const PRESS_RELEASES_PER_PAGE = 20;

export const FAMILIES_PAGES_SLUGS = {
  'logged-in': 'starlight-families-logged-in',
  'logged-out': 'starlight-families-logged-out',
};

export const FAMILIES_SIGNUP_LINK = 'https://www.tfaforms.com/5080470';

export const STARLIGHT_EMAIL_SUFFIX = '@starlight.org';

// media queries
export const MOBILE_BREAKPOINT = '(max-width: 768px)';
